import state from './daylockdownhub.state'
import mutations from './daylockdownhub.mutations'
import actions from './daylockdownhub.actions'

export default {
  state,
  mutations,
  actions
}
